<script setup lang="ts">
import { onServerPrefetch, useSSRContext, watch, onBeforeMount, computed } from 'vue';
import { useRoute } from 'vue-router'
import { useAppStore } from '@@home/stores/app';

export interface ItemType {
  path: string,
  label: string
}

const props = defineProps({
  itemList: {
    type: Array<ItemType>,
    default: () => []
  },
  defaultTitle: {
    type: String,
    default: ''
  }
});

const appStore = useAppStore();
const route = useRoute()

// 在路由变化时更新 selectedIndex
const selectedIndex = computed(() => props.itemList.findIndex((item) => item.path === route.path));

const getTitle = () => props.defaultTitle ? `${props.itemList[selectedIndex.value].label} - ${props.defaultTitle}` : props.itemList[selectedIndex.value].label;

onBeforeMount(() => {
  appStore.setTitle(getTitle());
});

onServerPrefetch(async () => {
  const ctx = useSSRContext() as Record<string, any>;
  ctx.title = getTitle()
});

watch(() => route.path, () => {
  appStore.setTitle(getTitle());
});
</script>

<template>
  <div class="mx-auto container">
    <div class="relative mb-48px mt-[45px] w-full flex items-center justify-between">
      <div v-for="(item, index) in props.itemList" :key="item.path">
        <RouterLink
          class="mb-16px box-border block w-[340px] items-center break-words px-10px text-center text-balance text-[24px] leading-[36px] no-underline <2xl:w-300px focus-visible:outline-unset"
          :class="[selectedIndex === index ? 'text-[#1180FF]' : 'text-[#2D2D2D]']"
          :to="item.path"
        >
          {{ item.label }}
        </RouterLink>
      </div>

      <div class="absolute bottom-0 left-0 h-2px w-340px bg-[#1180ff] transition-transform duration-300 <2xl:w-300px" :style="{ transform: `translateX(${selectedIndex * 100}%)` }"></div>
    </div>

    <RouterView />
  </div>
</template>
